import React from 'react';

function DevelopersGuide() {
  return <div>Developers Guide - To come</div>;
}

export default DevelopersGuide;
